import React, { useState } from 'react';
import Sidebar from './Sidebar';
import NotificationBell from './NotificationBell';
import { useAuth } from '../contexts/AuthContext';
import { Users, Briefcase, Menu, X } from 'lucide-react';
import './Layout.css';

const Layout = ({ children }) => {
  const { user } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 18) return 'Good Afternoon';
    return 'Good Evening';
  };

  const getUserInitials = () => {
    const firstName = user?.firstName || '';
    const lastName = user?.lastName || '';
    if (firstName && lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
    }
    return (user?.username || user?.role || 'AD').slice(0, 2).toUpperCase();
  };

  const displayName = user?.firstName 
    ? `${user.firstName}${user.lastName ? ' ' + user.lastName : ''}`
    : (user?.username || user?.role || 'Admin');

  return (
    <div className={`app-layout ${mobileMenuOpen ? 'mobile-menu-active' : ''}`}>
      <div 
        className={`mobile-overlay ${mobileMenuOpen ? 'visible' : ''}`}
        onClick={() => setMobileMenuOpen(false)}
      />
      <Sidebar mobileOpen={mobileMenuOpen} onCloseMobile={() => setMobileMenuOpen(false)} />
      <div className="layout-right">
        <header className="app-header hr-blue-banner">
          <div className="header-content">
            <div className="header-left">
              <button 
                className="mobile-menu-toggle"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                aria-label="Toggle navigation menu"
              >
                {mobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
              </button>
              <div className="hr-logo-badge">
                <div className="badge-icon-box">
                  <Users size={22} className="badge-icon" />
                </div>
                <div className="badge-text-box">
                  <span className="brand-title">HR PORTAL</span>
                </div>
              </div>

              <div className="header-divider"></div>

              <div className="greeting-section">
                <h1 className="greeting-text">{getGreeting()}, {displayName}!</h1>
                <p className="greeting-subtitle">
                  <Briefcase size={13} style={{ display: 'inline', marginRight: 4 }} />
                  Welcome back to your Enterprise HR Platform
                </p>
              </div>
            </div>

            <div className="header-right">
              <NotificationBell />

              <div className="user-profile">
                <div className="user-avatar">
                  {getUserInitials()}
                </div>
                <div className="user-info">
                  <span className="user-name">{displayName}</span>
                  <span className="user-role">{user?.role || 'Administrator'}</span>
                </div>
              </div>
            </div>
          </div>
        </header>

        <main className="main-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
